import { Fragment, useEffect, useState } from 'react';
import styled from 'styled-components';
import { find } from 'ramda';
import Loading from '~~elements/Loading';
import Button from '~~elements/Button';
import { PHONE_WIDTH } from '~~elements/Const';
import RMultilingual from '../Multilingual';
import ReviewTeamModal from './ReviewTeamModal';
import ReviewTeamImportModal from './ReviewTeamImportModal';
import ProgramPrint from '../../../ProgramPrint';
import { useRegistryState } from '../useRegistry';

const StyledDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: start;
  gap: 0.5rem;
  padding: 0 0.5rem;
  .team {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #eee;
    &--description {
      display: grid;
      grid-template-columns: 2fr 2fr;
      gap: 0.5rem;
      > div {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }
    &--action {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      gap: 0.3rem;
    }
  }

  @media (max-width: ${PHONE_WIDTH}) {
    .team {
      &--description {
        font-size: 0.8rem;
      }
      &--action {
        flex-direction: column;
        justify-content: center;
      }
    }
  }
`;

const ReviewTeamList = ({ loading, teams, reload, setTeams }) => {
  const { registryInfo } = useRegistryState();

  const [displayTeam, setDisplayTeam] = useState(null);
  const [forPrintTeam, setForPrintTeam] = useState(null);
  const [forImportTeam, setForImportTeam] = useState(null);

  useEffect(() => {
    setDisplayTeam(null);
  }, [teams]);

  if (loading) {
    return <Loading width="5rem" />;
  }

  if (teams.length === 0) {
    return <span>{RMultilingual(`COMMON.NONE`)}</span>;
  }

  const printTeam = (team) => () => {
    if (forPrintTeam && forPrintTeam.uniqid === team.uniqid) {
      setForPrintTeam(null);
      return;
    }
    setForPrintTeam(team);
  };

  const importTeam = (team) => () => {
    setForImportTeam(team);
  };

  const handleAfterImportedSetTeams = (newTeams) => {
    const inImportModalTeam = find((t) => t.uniqid === forImportTeam.uniqid, newTeams);
    setForImportTeam(inImportModalTeam);
    setTeams(newTeams);
  };

  const viewTeam = (team) => () => {
    setDisplayTeam(team);
  };

  return (
    <StyledDiv>
      {teams.map((team, index) => (
        <Fragment key={index}>
          <div className="team">
            <div className="team--description">
              <div>
                <span>{!team.connected_team ? team.city : team.connected_team.city}</span>
                <span>{team.name}</span>
              </div>
              <div>
                <span>{team.contact_person}</span>
                <span>{team.contact_phone}</span>
              </div>
            </div>
            <div className="team--action">
              {team.status === 'COMPLETED' && (
                <Fragment>
                  <Button mini color="blue" width="unset" nowrap onClick={printTeam(team)}>
                    {RMultilingual(`PRINT.WORDING`)}
                  </Button>
                  <Button
                    mini
                    color={!team.imported_team ? 'blue' : 'red'}
                    width="unset"
                    nowrap
                    onClick={importTeam(team)}
                  >
                    {!team.imported_team
                      ? RMultilingual(`REVIEW.IMPORT_TO_TOURNAMENT`)
                      : RMultilingual(`REVIEW.IMPORTED_TO_TOURNAMENT`)}
                  </Button>
                </Fragment>
              )}
              <Button mini color="blue" width="unset" nowrap onClick={viewTeam(team)}>
                {RMultilingual(`COMMON.VIEW`)}
              </Button>
            </div>
          </div>
          {forPrintTeam && forPrintTeam.uniqid === team.uniqid && (
            <ProgramPrint teamInRegistry={forPrintTeam} registry={registryInfo} wordingProgram={true} />
          )}
        </Fragment>
      ))}
      {displayTeam && <ReviewTeamModal team={displayTeam} toClose={viewTeam(null)} reload={reload} />}
      {forImportTeam && (
        <ReviewTeamImportModal team={forImportTeam} toClose={importTeam(null)} setTeams={handleAfterImportedSetTeams} />
      )}
    </StyledDiv>
  );
};

export default ReviewTeamList;
